import { Component, OnInit, OnDestroy, ViewChild, Inject } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { Router, DefaultUrlSerializer } from '@angular/router';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ServerService } from '../../../service/server/server.service';
import { Params, ActivatedRoute } from '@angular/router';
import { MatSort, MatSortable } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SalePaymentDetaileComponent } from "../sale-payment-detaile/sale-payment-detaile.component";

@Component({
  selector: 'app-sale-payments-list2',
  templateUrl: './sale-payments-list2.component.html',
  styleUrls: ['./sale-payments-list2.component.scss']
})
export class SalePaymentsList2Component implements OnInit, OnDestroy {
  //**********************************************************
  public username: string;
  user_info: any;
  user_id: number;
  public server: string;
  public site: string;
  public lang: any;
  public loading = false;
  public subscription: Subscription;
  public err: string; public err_validation: boolean = false;
  public err_internet_text: string; public err_internet_validation: boolean;
  public type_task: number;
  public confirm_delete: boolean;
  public count_total: number = 1; public page_number_first: number; public page_number_second: number; public page: number = 1;
  public code: any;
  sort: string;
  public show_excel: boolean = false;
  export_code: string;
  type_taskLnumber;
  public type: number; public type_search: number;
  //******************************************************************************
  public obj = {};
  public data = {};
  public list_record: any = [];
  public list_status: any = [];
  //******************************************************************************
  public id: number;
  public pre_status: boolean; public next_status: boolean; public new_status: boolean;
  public status_id: number; public status_id_search: number;
  public title: string; public title_search: string;
  search_array: any = [];
  search_all: string;
  //************
  public mat_table_selectedRow: any;
  public mat_table_hoverRow: any;
  dataSource;
  displayedColumns = ['row', 'title', 'payment', 'date3', 'creator', 'id', 'operation'];
  //*************
  form1_group: FormGroup;
  form1_search_group: FormGroup;
  invoice: number;
  //************** */
  constructor(public serverService: ServerService,
    public ngxSmartModalService: NgxSmartModalService, public router: Router
    , public activatedRoute: ActivatedRoute, public matSnackBar: MatSnackBar, private dialog: MatDialog
    , private dialogRef: MatDialog
    , private matDialogRef: MatDialogRef<SalePaymentsList2Component>
    , @Inject(MAT_DIALOG_DATA) public dialog_data: any) {
    if (dialog_data) {
      this.invoice = dialog_data.invoice;
    }
  }

  ngOnInit() {
    this.serverService.status1(2);
    this.server = this.serverService.get_server();
    this.site = this.serverService.get_site();
    this.lang = JSON.parse(<any>localStorage.getItem('lang'));
    this.user_info = JSON.parse(<any>localStorage.getItem('user_info'));
    if (this.user_info) {
      this.user_id = this.user_info.user_id;
    }
    this.check_access(4, 1, '', 1, 1);
    //**************
  }//end ngOnInit

  //****************************************************************************
  check_access(type_task, page, id, excel, loading) {
    if (this.serverService.check_internet()['status'] == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    if (loading == 1) this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { 'address': 6, user_id: this.user_id, id: 64 }).subscribe(
      (res) => {
        if (res['status'] == 1) {
          if (res['result'][0].count == 0) {
            //this.serverService.signout();
            var pe_message = "شما دسترسی به این سرویس را ندارید";
            var pe_action = "بستن";
            this.recieve_message(true, 'Access restrictions', pe_message, 1, 'close', pe_action);
          }
          else {
            this.title = res['result'][0].title;
            this.loading = false;
            if (type_task == 3) { this.delete(id); }
            if (type_task == 4) { this.load_data(page, excel, loading); }
          }
        }//end if
        else {
          var pe_message = "خطا در دسترسی";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }

  load_data(page, excel, loading) {
    if (this.serverService.check_internet()['status'] == false) {
      this.err_internet_validation = true;
      this.err_internet_text = this.serverService.check_internet()['title'];
      return;
    }//end if
    else { this.err_internet_validation = false; }
    if (loading == 1) {
      this.loading = true;
    }
    if (page == 2) { this.page = this.page + 1; }
    if (page == 4) { this.page = Math.ceil(this.count_total / 20); }
    if (page == 3) { this.page = this.page - 1; }
    if (page == 5) { this.page = 1; }
    if (page == 6) { this.page = 1; }
    var obj = {
      'address': 1531, "page": this.page, 'type': this.type
      , 'excel': excel
      , user_id: this.user_id
      , search: this.search_array
      , search_all: this.search_all
      , invoice: this.invoice
    }

    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res) => {
        this.data = res;
        if (this.data['status'] == 1) {
          if (excel == 1) {
            this.list_record = [];
            for (var i = 0; i < this.data['num']; i++) {
              this.list_record.push(this.data['result'][i]);
            }//end for
            this.dataSource = new MatTableDataSource(this.list_record);
            this.count_total = res['count'];
            this.pages(0);
            this.serverService.window_dialog_size();
          }
          else if (excel == 2) {
            this.show_excel = true;
            this.export_code = res['export_code'];
          }
          this.recieve_message(false, "", "", 1, "", "");
          this.serverService.send_services_id(this.code);
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }//end else
      }//end res:Response
    ) //ens dubscribe
  }//end load data

  pages(count) {
    this.count_total = this.count_total + count;
    this.page_number_first = this.page * 20 - 19;
    this.page_number_second = this.page * 20;
    if (this.page_number_first == 1) { this.pre_status = true; this.new_status = false; }
    else { this.pre_status = false; this.new_status = true; }
    if (this.list_record.length < 20) { this.page_number_second = this.count_total; this.next_status = true }//end if
    else { this.next_status = false; }
  }




  new() {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 1538, id: this.invoice, user_id: this.user_id }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.open_detaile(-1, 2, res['id']);
          this.recieve_message(false, "", "", 1, "", "");
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }
  //***************************************************************************
  open_detaile(i, type_task, id) {
    const dialogRef = this.dialog.open(SalePaymentDetaileComponent, {
      width: '45rem',
      height: 'auto',
      disableClose: true,
      data: { type_task: type_task, id: id, i: i, search_array: this.search_array, code: 64, title: this.title, invoice: this.invoice }
    });
    dialogRef.afterClosed().subscribe(
      (res) => {
        if (res) {
          if (type_task == 1 || i == -1) {
            this.list_record.unshift(res.result);
            this.dataSource = new MatTableDataSource(this.list_record);
            this.pages(1);
          }
          else if (type_task == 2) {
            this.list_record[res.i].sale_payment_title = res.result.sale_payment_title;
            this.list_record[res.i].sale_payment_price = res.result.sale_payment_price;
            this.list_record[res.i].sale_payment_date3 = res.result.sale_payment_date3;
            this.list_record[res.i].sale_payment_sort = res.result.sale_payment_sort;
            this.list_record[res.i].status_title = res.result.status_title;
            this.list_record[res.i].creator = res.result.creator;
          }
          else if (type_task == 3) {
            this.page = 1;
            this.search_array = [];
            this.search_array = res;
            this.check_access(4, 1, 0, res.export_excel, 1);
          }
        }
      }
    )
  }

  get_bg(id) {
    this.id = id;
  }

  delete_file(id) {

  }

  close() {
    this.matDialogRef.close();
  }
  //*******************************************************************************
  delete(id) {
    if (this.serverService.check_internet()['status'] == false) {
      this.err_internet_validation = true;
      this.err_internet_text = this.serverService.check_internet()['title'];
      return;
    }//end if
    else { this.err_internet_validation = false; }
    this.id = id;
    var confirm_delete;
    if (this.lang == '1') {
      confirm_delete = confirm("آيا شما از حدف اطمينان داريد ؟");
      this.loading = false;
    }//end if
    if (this.lang == '2') {
      confirm_delete = confirm("Are you sure for delete");
      this.loading = false;
    }//end if
    if (confirm_delete == true) {
      this.loading = true;
      this.subscription = this.serverService.post_address(this.server, 'new_address', { 'address': 1534, "user_id": this.user_id, 'id': id, "page": this.page, 'type': this.type, search: this.search_array }).subscribe(
        (res) => {
          if (res['status'] == 1) {
            for (var i = 0; i < this.list_record.length; i++) {
              if (this.list_record[i].sale_payment_id == id) {
                this.list_record.splice(i, 1);
              }//end if
            }//end for
            if (Object.keys(res['result']).length != 0) {
              this.id = res['result'][0].sale_payment_id;
              this.list_record.push(res['result'][0]);
            }//end Object.keys
            this.dataSource = new MatTableDataSource(this.list_record);
            this.pages(-1);
            this.recieve_message(false, "", "", 1, "", "");
          }//end if
          else if (res['status'] == 4) {
            var pe_message = "این رکورد در ماژول های در حال استفاده می باشد و قادر به حذف نخواهید بود";
            var pe_action = "بستن";
            this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
          }
          else {
            var pe_message = "خطا در حذف";
            var pe_action = "بستن";
            this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
          }//end else
        }//end res:Response
      )//end this.subscription
    }//end this.confirm_delete == true    
  }//end delete
  //*******************************************************************************
  change_resize() {
    this.serverService.change_window_resize(1, '', 0);
  }//end change_resize
  //*******************************************************************************
  recieve_message(validation, en_message, pe_message, type, en_action, pe_action) {
    this.err_internet_validation = false;
    if (type == 1) this.loading = false;
    if (validation == true) {
      if (this.lang == 1) this.matSnackBar.open(pe_message, pe_action, { duration: 2000 });
      if (this.lang == 2) this.matSnackBar.open(en_message, en_action, { duration: 2000 });
    }//end if
    else {
      //this.matSnackBar.dismiss();
    }
  }//end 
  //*******************************************************************************
  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }//end if
  }//end OnDestroy
}


